import { UserSettingsSchema } from '@app/core/api/user-settings';

/**
 * User settings state interface for NgRx store
 */
export interface UserSettingsState {
  settings: UserSettingsSchema | null;
  loading: boolean;
  error: string | null;
  cacheTimestamp: number | null;
}

/**
 * Initial state for user settings feature
 */
export const initialUserSettingsState: UserSettingsState = {
  settings: null,
  loading: false,
  error: null,
  cacheTimestamp: null
};
